import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    luaAnchor: {
        position: 'absolute',
        right: 55,
        bottom: 110,
        pointerEvents: 'none',

        [theme.breakpoints.up('md')]: {
            bottom: 50,
        },
    },
    horizontal: {
        position: 'static',
        width: 0,
        height: 0,
        transform: 'rotate(90deg)',
    },
}))
